module.exports = __webpack_public_path__ + "img/audioMaterial.35494d71.svg";